export const getTotalPercent = (percentageObj: GenericObject): number => {
  const total = Object.values(percentageObj).reduce((acc, val) => {
    const value = val || '0';

    return parseFloat(acc) + parseFloat(value);
  }, 0);

  return total;
};
